<template>
  <div class="page container">
      <div class="columns">
        <div class="column is-two-thirds">
          <h1 class="title is-size-4">Faça um contato</h1>
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="Seu nome">
              <el-input v-model="form.nome" placeholder="Seu nome" minlentgh="8"></el-input>
            </el-form-item>
            <el-form-item label="Seu e-mail">
              <el-input v-model="form.email" type="email" placeholder="Seu e-mail"></el-input>
            </el-form-item>
            <el-form-item label="Assunto">
              <el-input v-model="form.assunto" placeholder="Assunto" minlentgh="8"></el-input>
            </el-form-item>
             <el-form-item label="Conteúdo">
              <textarea class="textarea" placeholder="Escreva sua mensagem" v-model='form.conteudo' minlentgh="8"></textarea>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">Enviar</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="column">
            <div class="content">
              <h3>Estamos aqui</h3>
              <p>
                SEPS 705/905 bloco B sala 403<br />
                CEP: 70854-110<br />
                Brasília | Brasil
              </p>
              <gmap-map
                :center="center"
                :zoom="15"
                :options="mapOptions"
                style="width:100%;  height: 400px;"
              >
                <gmap-info-window :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen=false">
                  <span v-html='infoContent'></span>
                </gmap-info-window>
                <gmap-marker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  @click="toggleInfoWindow(m,index)"
                ></gmap-marker>
              </gmap-map>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import axios  from 'axios'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDcxWGkyFphwu44MJYHB1Ch7_YfBKVeONA',
    libraries: 'places,drawing', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    // If you want to set the version, you can do so:
    // v: '3.26',
  },
  // If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  // autobindAllEvents: false,
  // If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then disable the following:
  // installComponents: true,
});

export default {
  name: 'Contato',
  data() {
      return {
        form: {
          nome: '',
          assunto: '',
          conteudo: '',
          email: '',
         
        },
        center: { lat: -15.8049894, lng:-47.9040644},
        markers: [{ position: { lat: -15.8049894, lng:-47.9040644}, infoText: '<img src="/img/winnicotti_brasilia_logo.png" />' }],
        places: [],
        currentPlace: null,
        infoContent: '',
        infoWindowPos: null,
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        mapOptions: {
          disableDefaultUI: true,
        },
      }
    },
  methods:{
    onSubmit(){
      console.log(this.form)
      if(this.form.nome.length > 5 && this.form.assunto.length > 5 && this.form.email.length > 5){
        global.Loading.begin(`Enviando seu contato `);
          axios({
            method: 'post',
            url: `${global.base}/api/contato`,
            data: {
                nome: this.form.nome,
                assunto: this.form.assunto,
                conteudo: this.form.conteudo,
                email: this.form.email,
            },
            headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
            }).then((r)=>{
              global.Loading.end();
              this.curso = r.data;
            }).catch(()=>{
              global.Loading.end();
            })
          }else{
            this.$alert('Verifique se você preencheu o e-mail corretamente, e os campos não podem estar em branco ou com poucas informações.', 'Não pode enviar!', {
              confirmButtonText: 'OK',
              callback: action => {
                
              }
            });
          }
          
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      this.center = marker.position;
    },
  },
  mounted(){
  }
};
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .el-textarea__inner{
    height: 400px!important;
  }
  #gmap_canvas img {
      max-width: none!important;
      background: none!important
  } 
</style>
